<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner" title="Our Unique Approach" subtitle="Our Unique Approach"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


       <div class="container">
                
                <div class="row align-items-center ">
                    <!-- Left Side: Image -->
                    <div class="col-lg-6 col-md-12 m-b10">
                        <div class="image-container text-center">
                            <img src="assets/images/sm2.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                        </div>
                    </div>
                
                    <!-- Right Side: Text Content -->
                    <div class="col-lg-6 col-md-12">
                        <div class="text-content">
                            <div class="separator-line mb-4"></div>
                            <h5>Our Unique Approach
                            </h5>
                            <p >
                                Soul Space integrates cutting-edge technology with time-honored mindfulness practices to create a holistic mental health program:
                            </p>
                                <ul class="centered-list">
                                    <li>Virtual Reality Meditation Pods Immersive experiences tailored to individual emotional needs.</li>
                                    <li>AI-Powered Emotion Recognition Real-time support based on facial expressions and voice patterns.</li>
                                    <li>Biofeedback Wearables Helping students understand and regulate their physiological responses to stress.</li>
                                    <li>Peer Support Networks Fostering connections and empathy among students.</li>
                                </ul>
                
                            
                        </div>
                    </div>
                </div>
            </div>

    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>
